import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import { elementAdvantagePairs, elementLabel, elementIcon, elementColor } from '../../common';
export default class ElementsGuideModal extends Modal {
  className() {
    return 'ElementsGuideModal Modal--small';
  }
  title() {
    return m('[', null, m("i", {
      className: "fas fa-clone"
    }), ' ', app.translator.trans('forumaker-arena.forum.elements_guide.title'));
  }

  /** One "X beats Y" line. */
  advantageRow(winner, loser) {
    return m("li", {
      key: `${winner}>${loser}`,
      className: "ElementsGuideModal-cycleRow"
    }, m("span", {
      className: "ElementsGuideModal-elementBadge",
      style: {
        '--arena-element-color': elementColor(winner)
      }
    }, m("i", {
      className: elementIcon(winner)
    }), " ", elementLabel(winner)), m("i", {
      className: "fas fa-long-arrow-alt-right ElementsGuideModal-arrow"
    }), m("span", {
      className: "ElementsGuideModal-elementBadge",
      style: {
        '--arena-element-color': elementColor(loser)
      }
    }, m("i", {
      className: elementIcon(loser)
    }), " ", elementLabel(loser)));
  }
  content() {
    // Built from the live roster (see common/elements.ts), so renaming an
    // element, restyling it, re-wiring its advantages or adding a brand-new
    // one in the admin panel shows up here with no code change. It used to
    // be a hardcoded five-element cycle.
    const pairs = elementAdvantagePairs();
    return m("div", {
      className: "Modal-body ElementsGuideModal-body"
    }, m("p", {
      className: "ElementsGuideModal-intro"
    }, app.translator.trans('forumaker-arena.forum.elements_guide.intro')), pairs.length === 0 ? m("p", {
      className: "ElementsGuideModal-empty"
    }, app.translator.trans('forumaker-arena.forum.elements_guide.no_advantages')) : m("ul", {
      className: "ElementsGuideModal-cycle"
    }, pairs.map(_ref => {
      let {
        winner,
        loser
      } = _ref;
      return this.advantageRow(winner, loser);
    })));
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/ElementsGuideModal', ElementsGuideModal);